import { QUESTION_TYPES } from '~/pages/const';
import { Maybe, QuizQuestionAnswer } from '~/types';

const isAnswerIdCorrectFormat = (id?: Maybe<string>) => !!id?.split('_')?.at(1);

const createCorrectAnswersByIdMap = (
  questionId: string,
  type: string,
  answers?: Maybe<Maybe<QuizQuestionAnswer>[]>,
) =>
  answers?.reduce<Record<`${string}_${string}`, boolean | number>>(
    (acc, answer, index) => ({
      ...acc,
      [!isAnswerIdCorrectFormat(answer?.id) ? `${questionId}_${answer?.id}` : answer?.id!]:
        type === QUESTION_TYPES.ordered ? index : Boolean(answer?.correct || ''),
    }),
    {},
  ) || {};

export default createCorrectAnswersByIdMap;
